import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalFooter,
  ModalHeader,
  ModalHeaderProps,
  ModalOverlay,
} from "@chakra-ui/react";
import React from "react";

export interface BaseModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  displayCloseButton?: boolean;
  title?: string;
  overlay?: React.ReactNode;
  size?: string | Record<string, string>;
  scrollBehavior?: "inside" | "outside";
  contentProps?: ModalContentProps;
  headerProps?: ModalHeaderProps;
}

const initialOverlay = <ModalOverlay />;

export const BaseModal = ({
  isOpen,
  onClose,
  children,
  title,
  displayCloseButton,
  overlay = initialOverlay,
  contentProps,
  headerProps,
  ...props
}: BaseModalProps) => {
  return (
    <>
      <Modal {...props} onClose={onClose} isOpen={isOpen} isCentered>
        {overlay}
        <ModalContent {...contentProps}>
          {title && (
            <>
              <ModalHeader {...headerProps}>{title}</ModalHeader>
              <ModalCloseButton />
            </>
          )}

          <ModalBody>{children}</ModalBody>
          {displayCloseButton && (
            <ModalFooter>
              <Button onClick={onClose}>Close</Button>
            </ModalFooter>
          )}
        </ModalContent>
      </Modal>
    </>
  );
};
